import {
  SET_SELECTED_EVENT, SET_SELECTED_EVENT_SUCCESS, SET_SELECTED_EVENT_FAILURE
} from '../actions/events';

let selectedEventReducer = (state={isLoading: false, selectedEvent: '', selectedUser: ''}, action) => {
  switch (action.type) {
    case SET_SELECTED_EVENT_SUCCESS:
      return {
        isLoading: false,
        selectedEvent: action.selectedEvent,
        selectedUser: action.selectedUser
      }
    case SET_SELECTED_EVENT_FAILURE:
      return {
        isLoading: false,
        error: action.error
      }
    case SET_SELECTED_EVENT:
      return {
        selectedEvent: null,
        selectedUser: null,
        isLoading: true,
      }
    default:
      return state;
  }
}

export default selectedEventReducer
